import InfoPopover from './InfoPopover';

function MapStyleSelect(props) {

	const handleChange = (e) => {
		props.setMapType(e.target.value);
		if (e.target.value === "grid") {
			props.setTimeSliderDisabled(true);
		} else {
			props.setTimeSliderDisabled(false);
		}
	};


	return (
		<div className="mb-4 pb-4 text-center">
			<h2 className="italic font-bold text-center mb-4 pt-6">Map Layers</h2>
			<form>
				<div className="flex justify-center">
					{
						props.mapType == "points" 
						? (
							<input type="radio" value="points" id="points" onChange={handleChange} name="mapType" checked={true} />
						)
						: (
							<input type="radio" value="points" id="points" onChange={handleChange} name="mapType" checked={false} />
						)
					}
					<label for="points" className="pl-1">Points</label>
					<InfoPopover content="Records of individual plant locations." />
				</div>
	            <div className="flex justify-center">
					{
						props.mapType == "heat" 
						? (
							<input type="radio" value="heat" id="heat" onChange={handleChange} name="mapType" checked={true} />
						)
						: (
							<input type="radio" value="heat" id="heat" onChange={handleChange} name="mapType" checked={false} />
						)
					}
					<label for="heat" className="pl-1">Heatmap</label>
					<InfoPopover content="Density of plant locations, as heat map." />
				</div>
				<div className="flex justify-center">
					{
						props.mapType == "grid" 
						? (
							<input type="radio" value="grid" id="grid" onChange={handleChange} name="mapType" checked={true} />
						)
						: (
							<input type="radio" value="grid" id="grid" onChange={handleChange} name="mapType" checked={false} />
						)
					}
					<label for="grid" className="pl-1">Grid</label>
					<InfoPopover content="10km grid showing 'location quotient' of density of historical observations compared to contemporary records. Red indicates a greater density of historical observations compared with contemporary records; blue indicates a lower density." />
				</div>
         	</form>
		</div>
	)
}

export default MapStyleSelect;